// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/suit-spade.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/solid/suit-spade'

import { Icon, type IconComponentProps } from '../icon'

export const SuitSpadeIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
